module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list@2x.d9425e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list@2x.png
// module id = 5gNd
// module chunks = 18